export function Forward(_ref) {
  let {
    children
  } = _ref;
  return children;
}